import Typography from '@transferz/fe-component-library/typography';
import { useLocalize } from 'localize-react';
import React, { forwardRef, PropsWithChildren } from 'react';

import { Journey } from '../../types/journey';
import { GeoPoint } from './GeoPoint';

type Props = {
  journey: Journey;
  googleApiKey: string;
  travellerPosition: any;
};

// eslint-disable-next-line react/display-name
const TravellerInfo = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(({
  journey, googleApiKey, travellerPosition,
}, ref) => {
  const { translate } = useLocalize();

  const timeDifference = (timeStr: string) => {
    // Parse the input time string and get the current time
    const inputTime = new Date(timeStr);
    const currentTime = new Date();
    const currentTimeUTC = new Date(
      currentTime.getUTCFullYear(),
      currentTime.getUTCMonth(),
      currentTime.getUTCDate(),
      currentTime.getUTCHours(),
      currentTime.getUTCMinutes(),
      currentTime.getUTCSeconds(),
    );

    const deltaMs = currentTimeUTC.getTime() - inputTime.getTime();
    const totalMinutes = Math.floor(deltaMs / 1000 / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Format the output
    if (hours === 1) {
      if (minutes) {
        return minutes === 1 ? `${hours} hour ${minutes} minute ago` : `${hours} hour ${minutes} minutes ago`;
      }
      return `${hours} hour ago`;
    }
    if (hours > 1) {
      if (minutes) {
        return minutes === 1 ? `${hours} hours ${minutes} minute ago` : `${hours} hours ${minutes} minutes ago`;
      }
      return `${hours} hours ago`;
    }
    return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`;
  };

  return (
    <div className="journey-info p-16 m-t-16" ref={ref}>
      <Typography variant="h5" color="dark" className="m-b-16">
        Traveller location
      </Typography>
      <GeoPoint
        googleApiKey={googleApiKey}
        position={journey?.originLocation?.position}
        center={travellerPosition ? travellerPosition.position : journey?.originLocation?.position}
        travellerPosition={travellerPosition}
        travellerPositionIcon={(
          <div>
            <svg width="48" height="48" viewBox="0 0 40 40">
              <circle cx="20" cy="20" fill="none" r="8" stroke="#0083A8" strokeWidth="2">
                <animate attributeName="r" from="8" to="20" dur="1.5s" begin="0s" repeatCount="indefinite" />
                <animate attributeName="opacity" from="1" to="0" dur="1.5s" begin="0s" repeatCount="indefinite" />
              </circle>
              <circle cx="20" cy="20" fill="#0083A8" r="10" />
            </svg>
          </div>
)}
      />
      {travellerPosition?.recordedAt && (
      <div className="m-t-16 traveller-position-date">
        Traveller location updated
        {' '}
        {timeDifference(travellerPosition.recordedAt)}
      </div>
      )}
    </div>
  );
});

export default TravellerInfo;
